import React from 'react'
import { Accordion, Header, Card, Grid, Button, Icon, Label } from 'semantic-ui-react'
// import TextTruncate from 'react-text-truncate'
import MediaQuery from 'react-responsive'

import Usuarios from '../../services/Usuarios'
import Nps from './Nps'
import IsDevIndicator from '../Ambiente/IsDevIndicator'
import Mensagem from '../Sistema/Mensagem'
import Mensagens from '../../Mensagens'
import './DetalheEvento.css'
import { ArrowRightAltOutlined } from '@material-ui/icons'


class DetalheEvento extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            mensagemErroInscricao: ''
        }
    }
    handleCertificado = () => {

        if (this.props.eventHandlers.onHandleCertificado)
            this.props.eventHandlers.onHandleCertificado(this.props.evento)
    }
    handleExclusao = () => {
        if (this.props.eventHandlers.onHandleExclusao) {
            this.props.eventHandlers.onHandleExclusao(this.props.evento)

        }
    }

    handleInscricao = () => {

        if (this.props.eventHandlers.onHandleInscricao) {
            this.props.eventHandlers.onHandleInscricao(this.props.evento)

        }
    }
    htmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }

    render() {

        let lblBotaoExcluir = this.props.evento.lblBotaoExcluir ? this.props.evento.lblBotaoExcluir : Mensagens.b4
        let lblBotaoInscrever = this.props.evento.lblBotaoInscrever
        let isInscricaoDisabled = this.props.evento.isInscricaoDisabled
        let isExclusaoDisabled = this.props.evento.isExclusaoDisabled

        let icExibeExcluir = this.props.evento.icInscrito && this.props.evento.icInscricaoAberta && (!this.props.evento.icMarcadaPresenca || !this.props.evento.icEmiteCertificado)
        let icExibeLabelAusente = this.props.evento.icInscrito && !this.props.evento.icMarcadaPresenca && this.props.evento.icEventoRealizado

        if (this.props.evento.icEventoRealizado) {
            isInscricaoDisabled = true
            isExclusaoDisabled = true
        }


        const button =
            <Button onClick={() => this.handleInscricao()} className='button type1 p'
                disabled={isInscricaoDisabled}
                content={lblBotaoInscrever}
            />

        const buttonExcluir =
            <Button as='div' onClick={() => this.handleExclusao()} className='button p' 
                disabled={isExclusaoDisabled}
                labelPosition='right'
                animated='fade'>
                <Button icon color='black' >
                    <Icon name='trash'/>
                    {lblBotaoExcluir}
                </Button>
            </Button>

        const c = <div>
            {!this.props.icExibeNPS &&
                <div>

                    
                    {(this.props.evento.dePreletor !== '' && this.props.evento.dePreletor !== null) && <div><span className='strong'><Icon name='microphone' />Palestrante: </span>{this.props.evento.dePreletor}</div>}
                    {(this.props.evento.deConvidado !== '' && this.props.evento.deConvidado !== null) && <div><span className='strong'><Icon name='user plus' />Convidados: </span>{this.props.evento.deConvidado}</div>}
                    {(this.props.evento.deCoordenador !== '' && this.props.evento.deCoordenador !== null) && <div><span className='strong'><Icon name='black tie' />Coordenador: </span>{this.props.evento.deCoordenador}</div>}
                    {this.props.evento.nmCurso !== '' && <div><span className='strong'> <Icon name='student' />Curso: </span><span dangerouslySetInnerHTML={{ __html: this.props.evento.nmCurso }}></span></div>}
                    {icExibeLabelAusente && <Label size='small' ><Icon name='ticket' disabled />{Mensagens.m57}</Label>}

                </div>
            }
            {this.props.icExibeNPS &&
                <Nps onEndAvaliacaoNPS={() => this.props.eventHandlers.onEndAvaliacaoNPS()} inscricao={this.props.evento}></Nps>
            }
        </div>

        const t = <div className='displayInline'>
            <span className='strong'>{this.props.evento.deTituloEvento}</span>
            {this.props.evento.deLocalEvento !== '' && <div><span className='strong'> <Icon name='point' />Local: </span><span dangerouslySetInnerHTML={{ __html: this.props.evento.deLocalEvento }}></span></div>}
            <div><span className='strong'><Icon name='calendar' />Data da atividade:</span> {`${this.props.evento.dtInicio} às ${this.props.evento.dtFim}`}</div>
            <div><span className='strong'><Icon name='wait' />Horário:</span> {`${this.props.evento.horaInicio} às ${this.props.evento.horaFim}`}</div>
            {<div><span className='strong'><Icon name='users' />Vagas:</span> {this.props.evento.nuVagasDisponiveis >= 0 ? this.props.evento.nuVagasDisponiveis : 0}</div>}
            {(this.props.evento.deLinkAcessoRemoto !== '' && this.props.evento.deLinkAcessoRemoto !== null) && <div><span className='strong'><Icon name='linkify' />Link acesso remoto: </span><a href={this.props.evento.deLinkAcessoRemoto} target="_blank">{this.props.evento.deLinkAcessoRemoto}</a></div>}
            {c}        
        </div>

        return <Card fluid={this.props.icExibeNPS} key={this.props.evento.idEventoCongresso} className='resetCorners resetBorders' style={{ width: '100%', backgroundColor: '#E4E4E4' }}  >
            <IsDevIndicator corner exibeAmbiente={false} size='tiny' content={this.props.evento.idEventoCongresso} ></IsDevIndicator>
            {this.props.evento.icInscrito && (
                <Label 
                    color='green' 
                    className='no-radius-card-label'
                    icon='check circle'
                    content='Inscrito'
                />
            )}
            <Grid key={this.props.evento.idEventoCongresso} divided padded verticalAlign='middle' >
                <Grid.Row >
                    <Grid.Column width="12">
                        {t}

                        {!this.props.icExibeNPS &&
                            <div>
                                <div style={{ margin: '10px 0' }}>
                                    {
                                        Usuarios.isAuthenticated() &&
                                        <div>

                                            {this.state.mensagemErroInscricao &&
                                                <Mensagem
                                                    error
                                                    Header={Mensagens.m36}
                                                    Content={this.state.mensagemErroInscricao} />}

                                            {!this.props.evento.icInscrito && button}
                                            {icExibeExcluir && buttonExcluir}

                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </Grid.Column>

                    {/*computador */}
                    <MediaQuery minWidth={600}>
                        <Grid.Column width="4">
                            <Header as='h1' icon textAlign='center' >
                                <Header.Content>{this.props.evento.diaEvento}</Header.Content>
                                <Header.Subheader>{this.props.evento.mesEvento}</Header.Subheader>
                                <Header.Subheader content={`${this.props.evento.horaInicio} às ${this.props.evento.horaFim}`} />
                            </Header>
                        </Grid.Column>
                    </MediaQuery>

                </Grid.Row>
            </Grid>
        </Card>

    }



}

export default DetalheEvento


// WEBPACK FOOTER //
// ./src/components/Eventos/DetalheEvento.js